export default {
  colors: {
    primaryBlue: "#009fe3",
    secondaryBlue: "#002b47",
    tertiaryBlue: "#33b2e9",
    white: '#ffffff'
  }
};